import { FadeUp, Eyebrow, MaskedLines } from "@/components/Reveal";

const SectionTitle = ({ children }) => (
  <h2 className="font-serif text-xl sm:text-2xl text-[#F5F3EE]">{children}</h2>
);

const Para = ({ children }) => (
  <p className="mt-4 text-sm sm:text-base leading-relaxed text-[#969696]">{children}</p>
);

const Strong = ({ children }) => <strong className="font-semibold text-[#F5F3EE]">{children}</strong>;

export default function CookiePolicy() {
  return (
    <main data-testid="cookie-policy-page">
      <section className="relative overflow-hidden pt-32 pb-10 lg:pt-44 lg:pb-14 grain" data-testid="cookie-hero">
        <div className="pointer-events-none absolute -top-40 left-1/2 h-[480px] w-[720px] -translate-x-1/2 rounded-full bg-gold/[0.05] blur-[120px]" />
        <div className="relative mx-auto max-w-4xl px-6 sm:px-8">
          <FadeUp>
            <Eyebrow>Legale</Eyebrow>
          </FadeUp>
          <MaskedLines
            className="mt-6"
            delay={0.15}
            lineClassName="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-[#F5F3EE] tracking-tight"
            lines={[
              "Informativa",
              <>
                sui <span className="gold-text gold-text-animated italic">Cookie.</span>
              </>,
            ]}
          />
          <FadeUp delay={0.4} className="mt-6">
            <p className="font-serif italic text-lg text-gold/90">Cookie Policy</p>
            <p className="mt-2 text-sm text-[#969696]">
              Ai sensi del Provvedimento del Garante Privacy e del Regolamento UE 2016/679
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="pb-16 lg:pb-24" data-testid="cookie-content">
        <div className="mx-auto max-w-4xl px-6 sm:px-8">
          <FadeUp className="border-t border-[#1A1A1A] pt-10">
            <SectionTitle>1. Cosa sono i Cookie</SectionTitle>
            <Para>
              I cookie sono piccoli file di testo che i siti visitati dagli utenti inviano ai loro terminali, dove
              vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.
            </Para>
          </FadeUp>

          <FadeUp className="mt-10 border-t border-[#1A1A1A] pt-10">
            <SectionTitle>2. Tipologie di Cookie Utilizzati da Questo Sito</SectionTitle>
            <Para>
              Questo sito web utilizza <Strong>esclusivamente cookie tecnici</Strong>.
            </Para>
            <ul className="mt-4 space-y-4">
              <li className="text-sm sm:text-base leading-relaxed text-[#969696]">
                <Strong>Cookie Tecnici di Navigazione o Sessione:</Strong> Sono indispensabili per il corretto
                funzionamento delle pagine, per la gestione dell'infrastruttura di navigazione e per la sicurezza
                del sito. Per l'installazione di tali cookie non è richiesto il preventivo consenso dell'utente
                (art. 122 del D.Lgs. 196/2003 e successive modifiche).
              </li>
              <li className="text-sm sm:text-base leading-relaxed text-[#969696]">
                <Strong>Cookie di Profilazione e Terze Parti:</Strong> Questo sito <Strong>NON</Strong> fa uso di
                cookie di profilazione pubblicitaria proprietari né installa traccianti di terze parti a scopo di
                remarketing o profilazione comportamentale.
              </li>
            </ul>
          </FadeUp>

          <FadeUp className="mt-10 border-t border-[#1A1A1A] pt-10">
            <SectionTitle>3. Gestione e Disabilitazione dei Cookie</SectionTitle>
            <Para>
              L'utente può comunque gestire, disabilitare o cancellare i cookie attraverso le impostazioni del
              proprio browser di navigazione (Google Chrome, Mozilla Firefox, Apple Safari, Microsoft Edge). La
              disattivazione totale dei cookie tecnici potrebbe compromettere la corretta visualizzazione di alcune
              sezioni del sito.
            </Para>
          </FadeUp>

          <FadeUp className="mt-10 border-t border-b border-[#1A1A1A] pt-10 pb-10">
            <SectionTitle>4. Titolare del Trattamento e Contatti</SectionTitle>
            <Para>
              Titolare del trattamento: <Strong>Iconic Elite Management S.R.L.S.</Strong>, Via Martino Cilestri 71,
              95127 Catania (CT) — Email:{" "}
              <a href="mailto:1pietrolicandro@gmail.com" className="text-gold transition-colors hover:text-gold-bright">
                1pietrolicandro@gmail.com
              </a>{" "}
              — PEC:{" "}
              <a href="mailto:iconic_elite@pec.it" className="text-gold transition-colors hover:text-gold-bright">
                iconic_elite@pec.it
              </a>
              .
            </Para>
          </FadeUp>
        </div>
      </section>
    </main>
  );
}
